<Header class="header">
  <nav class="logo" style="cursor: pointer;" (click)="goHome()">
    <img src="/assets/images/logo-prefeitura.svg" alt="logo da prefeitura" />
    <img src="/assets/images/logo-seplaf.svg" alt="logo da seplaf" />
  </nav>

  <nav class="menu-toggle-container" [class.aberto]="menuOpen" (click)="toggleMenu()">
    <div class="menu-toggle">
    <img src="/assets/icons/menu.svg" alt="menu-icon" />
    </div>
  </nav>

  <nav class="menu" [class.active]="menuOpen">
    @for (item of menuItens; track item.path) {
    <span
      (click)="navigate(item.path)"
      [class.ativo]="activedItem(item.path)"
    >
      {{ item.nome }}
    </span>
    }
    <!-- <button
      (click)="navigate('participacao')"
      [disabled]="!participationEnabled"
      [ngClass]="{
        'animate-pulse bg-yellow-300 text-black': participationEnabled,
        'bg-gray-400 text-white cursor-not-allowed': !participationEnabled
      }"
      class="rounded-lg py-2 px-6 font-bold ml-1 transition-all duration-300"
    >
      PARTICIPE
    </button> -->
  </nav>

  @if (menuOpen) {
  <nav class="overlay" (click)="closeMenu()"></nav>
  }
</Header>
